<template>
    <div class="main">
        <c-panel title="RELATÓRIOS DO ALMOXARIFADO" titleIcon="fas fa-file-alt">
            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-form-item label="Relatório">
                            <el-select v-model="tipo" placeholder="Selecione" style="width:100%;" @change="trocarTipo">
                                <el-option v-for="t in tipos" :key="t.valor" :label="t.nome" :value="t.valor"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Cada relatório mostra só os filtros que usa. -->
                    <el-col :xs="24" :sm="12" :md="8" v-if="usa('unidade')">
                        <el-form-item :label="tipo === 'requisicoes' ? 'Solicitante' : 'Unidade'">
                            <el-select v-if="ehSmed" v-model="filtro.instituicao_id" filterable
                                :clearable="tipo === 'requisicoes'" :placeholder="tipo === 'requisicoes' ? 'Todas' : 'Selecione'"
                                style="width:100%;">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                            <el-input v-else :value="nomeInstituicao" disabled></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="12" :md="8" v-if="usa('grupo')">
                        <el-form-item label="Grupo de Material">
                            <el-select v-model="filtro.grupo_id" filterable clearable placeholder="Todos" style="width:100%;">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="12" :sm="6" :md="4" v-if="usa('periodo')">
                        <el-form-item label="De">
                            <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" :md="4" v-if="usa('periodo')">
                        <el-form-item label="Até">
                            <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="8" :md="4" v-if="usa('situacao_requisicao')">
                        <el-form-item label="Situação">
                            <el-select v-model="filtro.status" clearable placeholder="Todas" style="width:100%;">
                                <el-option label="Aberta" :value="1"></el-option>
                                <el-option label="Atendida" :value="2"></el-option>
                                <el-option label="Cancelada" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="8" :md="5" v-if="usa('tipo_fornecedor')">
                        <el-form-item label="Tipo de fornecedor">
                            <el-input v-model="filtro.tipo" clearable placeholder="Todos"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="4" v-if="usa('situacao_fornecedor')">
                        <el-form-item label="Situação">
                            <el-select v-model="filtro.situacao" clearable placeholder="Todos" style="width:100%;">
                                <el-option label="Ativos" value="1"></el-option>
                                <el-option label="Inativos" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" class="u-mt-10">
                    <el-col :xs="24" :sm="12">
                        <span class="dica">{{ descricao }}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" class="u-text-right">
                        <el-button :disabled="!tipo" icon="el-icon-view" plain @click="gerar('html')" class="u-mr-5">HTML</el-button>
                        <el-button :disabled="!tipo" icon="el-icon-document" plain type="success" @click="gerar('excel')" class="u-mr-5">EXCEL</el-button>
                        <el-button :disabled="!tipo" icon="el-icon-printer" type="primary" @click="gerar('pdf')">PDF</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
/**
 * Relatórios do almoxarifado.
 *
 * Um select escolhe o relatório e a tela mostra só os filtros que ele aceita —
 * exibir todos deixaria o usuário preenchendo campo que a consulta ignora.
 * Os três formatos usam o mesmo endpoint; o que muda é o parâmetro `formato`.
 */
export default {
    data: () => ({
        tipos: [],
        grupos: [],
        tipo: '',
        filtro: {}
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        nomeInstituicao () { return this.$store.state.config.instituicao.nome || '-' },
        /** Quais filtros cada relatório usa. */
        filtrosDoTipo () {
            return {
                inventario:     ['unidade', 'grupo'],
                estoque_minimo: ['unidade', 'grupo'],
                requisicoes:    ['unidade', 'periodo', 'situacao_requisicao'],
                entradas:       ['unidade', 'periodo'],
                transferencias: ['unidade', 'periodo'],
                fornecedores:   ['tipo_fornecedor', 'situacao_fornecedor']
            }[this.tipo] || []
        },
        descricao () {
            return {
                inventario:     'Todos os produtos da unidade, com mínimo, máximo, saldo e situação.',
                estoque_minimo: 'Só os produtos cujo saldo caiu abaixo do mínimo, com a quantidade que falta.',
                requisicoes:    'Requisições feitas ao almoxarifado, com o que foi solicitado e o que foi atendido.',
                entradas:       'Entradas de material, com documento, quantidade e valor.',
                transferencias: 'Transferências entre unidades, com origem e destino.',
                fornecedores:   'Fornecedores cadastrados, com CNPJ, tipo e contato.'
            }[this.tipo] || 'Escolha o relatório para ver os filtros disponíveis.'
        }
    },
    mounted () {
        this.carregarTipos()
        this.carregarGrupos()
        this.trocarTipo()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },
        usa (filtro) { return this.filtrosDoTipo.includes(filtro) },

        carregarTipos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-relatorio/tipos`, this.auth())
                .then(r => { this.tipos = r.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll?situacao=true`, this.auth())
                .then(r => { this.grupos = r.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        /** Trocar de relatório zera os filtros: os do anterior não valem para o novo. */
        trocarTipo () {
            this.filtro = {
                instituicao_id: this.ehSmed ? '' : this.$store.state.config.instituicao.id,
                grupo_id: '', data_inicio: '', data_fim: '', status: '', tipo: '', situacao: ''
            }
        },

        gerar (formato) {
            if (!this.tipo) { window.eventBus.$emit('alert', { msg: 'Selecione o relatório.', type: 'warning' }); return }

            if (this.usa('unidade') && this.tipo !== 'requisicoes' && !this.filtro.instituicao_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a unidade.', type: 'warning' })
                return
            }

            window.eventBus.$emit('loading', true)

            const payload = Object.assign({}, this.filtro, { tipo: this.tipo, formato })
            const mime = { pdf: 'application/pdf', html: 'text/html', excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }[formato]

            // O download exige o token, então o arquivo vem por XHR e vira blob —
            // um link direto seria recusado pela API.
            this.$axios.post(`${this.baseUrl()}/api/almox-relatorio/gerar`, payload,
                Object.assign({ responseType: 'blob' }, this.auth()))
                .then(res => {
                    window.eventBus.$emit('loading', false)

                    const url = URL.createObjectURL(new Blob([res.data], { type: mime }))

                    if (formato === 'excel') {
                        const a = document.createElement('a')
                        a.href = url
                        a.download = `almox_${this.tipo}.xlsx`
                        a.click()
                        return
                    }

                    window.open(url, '_blank')
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>

<style scoped>
.dica { color: #909399; font-size: 12px; }
</style>
